import React from 'react';
import classnames from 'classnames';
import commonDistance from './common-distance';
import type { SizeType } from './common-distance';
import './index.less';

/**
 * bg: boolean 是否需要bg
 * margin: boolean | {left: boolean, right: boolean, vertical: boolean, horizontal: boolean}
 * waterMaker: boolean
 */

interface PropsType {
  margin?: any;
  padding?: any;
  paddingSize?: SizeType;
  marginSize?: SizeType;
  className?: string;
  style?: React.CSSProperties;
  bg?: boolean;
  clearfix?: boolean;
  children: React.ReactNode;
}

const Container: React.FC<PropsType> = ({
  bg = true,
  margin = true,
  padding = false,
  className = '',
  children,
  clearfix,
  paddingSize = 'normal',
  marginSize = 'normal',
  style,
}) => {
  const classNames = classnames(
    commonDistance('margin', margin, marginSize),
    commonDistance('padding', padding, paddingSize),
    {
      'common-bg': bg,
      clearfix,
    },
    className
  );

  return (
    <div className={classNames} style={style}>
      {children}
    </div>
  );
};

export default Container;
